// Third party
import {
  FeaturesListAllDocument,
  FeaturesListAllQuery,
  PropertyType,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

export const imperativeNodeFeaturesQuery = async () => {
  const apolloClient = createApolloClient();

  return await apolloClient.query<FeaturesListAllQuery>({
    query: FeaturesListAllDocument,
    variables: { propertyType: PropertyType.BedAndBreakfast },
  });
};

export type FeaturePartial = FeaturesListAllQuery['featuresListAll'][0];
